import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media, breakpoints } from '@tds/core-responsive';
import { safeRest } from '@tds/util-helpers';
import { responsiveProps } from '@tds/util-prop-types';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;



var flexboxgrid2 = /*#__PURE__*/Object.freeze({
	'default': undefined
});

var _flexboxgrid = getCjsExportFromNamespace(flexboxgrid2);

var classNames = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClass;



var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClass(className) {
  return _flexboxgrid2.default && _flexboxgrid2.default[className] ? _flexboxgrid2.default[className] : className;
}
});

unwrapExports(classNames);

var createProps_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createProps;
function createProps(propTypes, props, classNames) {
  var newProps = {};

  Object.keys(props).filter(function (key) {
    return key === 'children' || !propTypes[key];
  }).forEach(function (key) {
    return newProps[key] = props[key];
  });

  var className = classNames.filter(function (cn) {
    return cn;
  }).join(' ');
  return Object.assign({}, newProps, { className: className });
}
});

unwrapExports(createProps_1);

var types = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewportSizeType = exports.ColumnSizeType = undefined;



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnSizeType = exports.ColumnSizeType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]);
var ViewportSizeType = exports.ViewportSizeType = _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']);
});

unwrapExports(types);
var types_1 = types.ViewportSizeType;
var types_2 = types.ColumnSizeType;

var Row_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRowProps = getRowProps;
exports.default = Row;



var _classNames2 = _interopRequireDefault(classNames);



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _createProps2 = _interopRequireDefault(createProps_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

var propTypes = {
  reverse: _propTypes2.default.bool,
  start: types.ViewportSizeType,
  center: types.ViewportSizeType,
  end: types.ViewportSizeType,
  top: types.ViewportSizeType,
  middle: types.ViewportSizeType,
  bottom: types.ViewportSizeType,
  around: types.ViewportSizeType,
  between: types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function getRowClassNames(props) {
  var modificators = [props.className, (0, _classNames2.default)('row')];

  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];
    if (value) {
      modificators.push((0, _classNames2.default)(key + '-' + value));
    }
  }

  if (props.reverse) {
    modificators.push((0, _classNames2.default)('reverse'));
  }

  return modificators;
}

function getRowProps(props) {
  return (0, _createProps2.default)(propTypes, props, getRowClassNames(props));
}

function Row(props) {
  return _react2.default.createElement(props.tagName || 'div', getRowProps(props));
}

Row.propTypes = propTypes;
});

unwrapExports(Row_1);
var Row_2 = Row_1.getRowProps;

var Col_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = getColumnProps;
exports.default = Col;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _createProps2 = _interopRequireDefault(createProps_1);



var _classNames2 = _interopRequireDefault(classNames);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  xs: types.ColumnSizeType,
  sm: types.ColumnSizeType,
  md: types.ColumnSizeType,
  lg: types.ColumnSizeType,
  xl: types.ColumnSizeType,
  xsOffset: _propTypes2.default.number,
  smOffset: _propTypes2.default.number,
  mdOffset: _propTypes2.default.number,
  lgOffset: _propTypes2.default.number,
  xlOffset: _propTypes2.default.number,
  first: types.ViewportSizeType,
  last: types.ViewportSizeType,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var classMap = {
  xs: 'col-xs',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xl: 'col-xl',
  xsOffset: 'col-xs-offset',
  smOffset: 'col-sm-offset',
  mdOffset: 'col-md-offset',
  lgOffset: 'col-lg-offset',
  xlOffset: 'col-xl-offset'
};

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

function getColClassNames(props) {
  var extraClasses = [];

  if (props.className) {
    extraClasses.push(props.className);
  }

  if (props.first) {
    extraClasses.push((0, _classNames2.default)('first-' + props.first));
  }

  if (props.last) {
    extraClasses.push((0, _classNames2.default)('last-' + props.last));
  }

  return Object.keys(props).filter(function (key) {
    return classMap[key];
  }).map(function (key) {
    return (0, _classNames2.default)(isInteger(props[key]) ? classMap[key] + '-' + props[key] : classMap[key]);
  }).concat(extraClasses);
}

function getColumnProps(props) {
  return (0, _createProps2.default)(propTypes, props, getColClassNames(props));
}

function Col(props) {
  var tagName = props.tagName,
      columnProps = _objectWithoutProperties(props, ['tagName']);

  return _react2.default.createElement(tagName || 'div', getColumnProps(columnProps));
}

Col.propTypes = propTypes;
});

unwrapExports(Col_1);
var Col_2 = Col_1.getColumnProps;

var Grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grid;



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _createProps2 = _interopRequireDefault(createProps_1);



var _classNames2 = _interopRequireDefault(classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fluid: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  tagName: _propTypes2.default.string,
  children: _propTypes2.default.node
};

function Grid(props) {
  var containerClass = (0, _classNames2.default)(props.fluid ? 'container-fluid' : 'container');
  var classNames = [props.className, containerClass];

  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(propTypes, props, classNames));
}

Grid.propTypes = propTypes;
});

unwrapExports(Grid_1);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnProps = exports.Col = exports.getRowProps = exports.Row = exports.Grid = undefined;



Object.defineProperty(exports, 'getRowProps', {
  enumerable: true,
  get: function get() {
    return Row_1.getRowProps;
  }
});



Object.defineProperty(exports, 'getColumnProps', {
  enumerable: true,
  get: function get() {
    return Col_1.getColumnProps;
  }
});



var _Grid3 = _interopRequireDefault(Grid_1);

var _Row3 = _interopRequireDefault(Row_1);

var _Col3 = _interopRequireDefault(Col_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Grid = _Grid3.default;
exports.Row = _Row3.default;
exports.Col = _Col3.default;
});

unwrapExports(lib);
var lib_1 = lib.getColumnProps;
var lib_2 = lib.Col;
var lib_3 = lib.getRowProps;
var lib_4 = lib.Row;
var lib_5 = lib.Grid;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var GutterContext = React.createContext(false);

/* eslint-disable import/prefer-default-export */
var deprecate = function deprecate(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  console.warn("[TDS] [Deprecate] ".concat(componentName, ": ").concat(message)); // eslint-disable-line no-console
};

var calculateLevel = function calculateLevel(xs, sm, md, lg, xl) {
  var levelToggles = [xs, sm, md, lg, xl];
  var enabledLevels = [false, false, false, false, false];

  for (var toggles = 0; toggles < levelToggles.length; toggles += 1) {
    for (var levels = toggles; levels < enabledLevels.length; levels += 1) {
      if (levelToggles[toggles] !== undefined) {
        enabledLevels[levels] = levelToggles[toggles];
      }
    }
  }

  return enabledLevels;
};

var StyledCol = styled(function (_ref) {
  var hiddenLevel = _ref.hiddenLevel,
      gutter = _ref.gutter,
      horizontalAlignLevel = _ref.horizontalAlignLevel,
      rest = objectWithoutProperties(_ref, ["hiddenLevel", "gutter", "horizontalAlignLevel"]);

  return React.createElement(lib_2, rest);
})(function (_ref2) {
  var hiddenLevel = _ref2.hiddenLevel,
      gutter = _ref2.gutter,
      horizontalAlignLevel = _ref2.horizontalAlignLevel;
  return _extends_1({
    'div&': {
      paddingLeft: gutter ? '1rem' : 0,
      paddingRight: gutter ? '1rem' : 0,
      flexGrow: 1
    }
  }, media.until('sm').css({
    display: hiddenLevel[0] === 0 ? 'none' : 'block',
    textAlign: horizontalAlignLevel[0]
  }), {}, media.from('sm').css({
    display: hiddenLevel[1] === 0 ? 'none' : 'block',
    textAlign: horizontalAlignLevel[1]
  }), {}, media.from('md').css({
    display: hiddenLevel[2] === 0 ? 'none' : 'block',
    textAlign: horizontalAlignLevel[2]
  }), {}, media.from('lg').css({
    display: hiddenLevel[3] === 0 ? 'none' : 'block',
    textAlign: horizontalAlignLevel[3]
  }), {}, media.from('xl').css({
    display: hiddenLevel[4] === 0 ? 'none' : 'block',
    textAlign: horizontalAlignLevel[4]
  }));
});

var Col = function Col(_ref3) {
  var span = _ref3.span,
      offset = _ref3.offset,
      horizontalAlign = _ref3.horizontalAlign,
      children = _ref3.children,
      rest = objectWithoutProperties(_ref3, ["span", "offset", "horizontalAlign", "children"]);

  if (offset) {
    deprecate('core-flex-grid', 'The `offset` prop is deprecated due to the addition of the responsive offset props. Use `xsOffset` instead.');
  }

  if (span) {
    deprecate('core-flex-grid', 'The `span` prop is deprecated due to the addition of the responsive props. Use `xs` instead.');
  }

  var props = _extends_1({}, rest);

  if (offset && !props.xsOffset) {
    props.xsOffset = offset;
  }

  var hiddenLevel = calculateLevel(rest.xs, rest.sm, rest.md, rest.lg, rest.xl);

  var horizontalAlignLevel = function horizontalAlignLevel() {
    if (_typeof_1(horizontalAlign) === 'object') {
      return calculateLevel(horizontalAlign.xs, horizontalAlign.sm, horizontalAlign.md, horizontalAlign.lg, horizontalAlign.xl);
    }

    if (typeof horizontalAlign === 'string') {
      return [horizontalAlign, horizontalAlign, horizontalAlign, horizontalAlign, horizontalAlign];
    }

    return ['inherit', 'inherit', 'inherit', 'inherit', 'inherit'];
  };

  return React.createElement(GutterContext.Consumer, null, function (gutter) {
    return React.createElement(StyledCol, _extends_1({}, safeRest(props), {
      xs: rest.xs || span || true,
      hiddenLevel: hiddenLevel,
      gutter: gutter,
      horizontalAlignLevel: horizontalAlignLevel()
    }), children);
  });
};
/* eslint-disable react/require-default-props */

/*
 * We're disabling default props since passing undefined props to
 * the react-flexbox-grid component sets up blank classes that may cause
 * styling issues.
 */


Col.propTypes = {
  /**
   * Specify number of columns within the 'xs' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  xs: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),

  /**
   * Specify number of columns within the 'sm' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  sm: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),

  /**
   * Specify number of columns within the 'md' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  md: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),

  /**
   * Specify number of columns within the 'lg' breakpoint range. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  lg: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),

  /**
   * Specify number of columns after the 'xl' breakpoint. `0` hides the column.
   *
   * `true` sets the column width automatically;
   * `false` disables the prop
   *
   * @since 1.2.0
   */
  xl: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, true, false]),

  /**
   * Offset the specified number of columns within the 'xs' breakpoint range. `0` hides the column.
   *
   * @since 1.2.0
   */
  xsOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * Offset the specified number of columns within the 'sm' breakpoint range.
   *
   * @since 1.2.0
   */
  smOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * Offset the specified number of columns within the 'md' breakpoint range.
   *
   * @since 1.2.0
   */
  mdOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * Offset the specified number of columns within the 'lg' breakpoint range.
   *
   * @since 1.2.0
   */
  lgOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * Offset the specified number of columns within the 'xl' breakpoint range.
   *
   * @since 1.2.0
   */
  xlOffset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * The columns of the Grid. Will typically be `FlexGrid.Col` components.
   *
   * @since 1.2.0
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated Span the specified number of columns.
   * @since 1.2.0
   *
   * Use the xs prop instead for identical functionality.
   */
  span: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * @deprecated Offset the specified number of columns.
   * @since 1.2.0
   *
   * Use the xsOffset prop instead for identical functionality.
   */
  offset: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),

  /**
   * @since 2.3.0
   *
   * Align content horizontally within the column.
   *
   *
   * Accepts a `PropType.string` following the [responsive prop](#/Layout?id=responsive) structure.
   */
  horizontalAlign: responsiveProps(PropTypes.string)
};
/* eslint-enable */

Col.defaultProps = {
  span: undefined,
  offset: undefined,
  horizontalAlign: undefined
};

var StyledRow = styled(function (_ref) {
  var reverseLevel = _ref.reverseLevel,
      rest = objectWithoutProperties(_ref, ["reverseLevel"]);

  return React.createElement(lib_4, rest);
})(function (_ref2) {
  var reverseLevel = _ref2.reverseLevel;
  return {
    width: '100%',
    'div&': _extends_1({
      margin: '0 auto',
      flexShrink: 0
    }, media.until('sm').css({
      flexDirection: reverseLevel[0] ? 'row-reverse' : 'row'
    }), {}, media.from('sm').css({
      flexDirection: reverseLevel[1] ? 'row-reverse' : 'row'
    }), {}, media.from('md').css({
      flexDirection: reverseLevel[2] ? 'row-reverse' : 'row'
    }), {}, media.from('lg').css({
      flexDirection: reverseLevel[3] ? 'row-reverse' : 'row'
    }), {}, media.from('xl').css({
      flexDirection: reverseLevel[4] ? 'row-reverse' : 'row'
    }))
  };
});

var Row = function Row(_ref3) {
  var horizontalAlign = _ref3.horizontalAlign,
      verticalAlign = _ref3.verticalAlign,
      distribute = _ref3.distribute,
      xsReverse = _ref3.xsReverse,
      smReverse = _ref3.smReverse,
      mdReverse = _ref3.mdReverse,
      lgReverse = _ref3.lgReverse,
      xlReverse = _ref3.xlReverse,
      children = _ref3.children,
      rest = objectWithoutProperties(_ref3, ["horizontalAlign", "verticalAlign", "distribute", "xsReverse", "smReverse", "mdReverse", "lgReverse", "xlReverse", "children"]);

  var getAlignment = function getAlignment() {
    return {
      start: horizontalAlign === 'start' ? 'xs' : undefined,
      center: horizontalAlign === 'center' ? 'xs' : undefined,
      end: horizontalAlign === 'end' ? 'xs' : undefined,
      top: verticalAlign === 'top' ? 'xs' : undefined,
      middle: verticalAlign === 'middle' ? 'xs' : undefined,
      bottom: verticalAlign === 'bottom' ? 'xs' : undefined
    };
  };

  var getDistribution = function getDistribution() {
    return {
      around: distribute === 'around' ? 'xs' : undefined,
      between: distribute === 'between' ? 'xs' : undefined
    };
  };

  var reverseLevel = calculateLevel(xsReverse, smReverse, mdReverse, lgReverse, xlReverse);
  return React.createElement(StyledRow, _extends_1({}, safeRest(rest), getAlignment(), getDistribution(), {
    reverseLevel: reverseLevel
  }), children);
};

Row.propTypes = {
  /**
   * Align columns horizontally within their row.
   */
  horizontalAlign: PropTypes.oneOf(['start', 'center', 'end']),

  /**
   * Align columns vertically within their row.
   */
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),

  /**
   * Distribute empty space around columns.
   */
  distribute: PropTypes.oneOf(['around', 'between']),

  /**
   * Choose if the item order should be reversed from the 'xs' breakpoint. When you pass in false, the order will be normal from the xs breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xsReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'sm' breakpoint. When you pass in false, the order will be normal from the sm breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  smReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'md' breakpoint. When you pass in false, the order will be normal from the md breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  mdReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'lg' breakpoint. When you pass in false, the order will be normal from the lg breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  lgReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'xl' breakpoint. When you pass in false, the order will be normal from the xl breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xlReverse: PropTypes.bool,
  children: PropTypes.node.isRequired
};
Row.defaultProps = {
  horizontalAlign: undefined,
  verticalAlign: undefined,
  distribute: undefined,
  xsReverse: undefined,
  smReverse: undefined,
  mdReverse: undefined,
  lgReverse: undefined,
  xlReverse: undefined
};

var rem = function rem(breakpoint) {
  return "".concat(breakpoints[breakpoint] / 16, "rem");
};

var StyledGrid = styled(function (_ref) {
  var reverseLevel = _ref.reverseLevel,
      limitWidth = _ref.limitWidth,
      outsideGutter = _ref.outsideGutter,
      rest = objectWithoutProperties(_ref, ["reverseLevel", "limitWidth", "outsideGutter"]);

  return React.createElement(lib_5, rest);
})(function (_ref2) {
  var reverseLevel = _ref2.reverseLevel,
      limitWidth = _ref2.limitWidth,
      outsideGutter = _ref2.outsideGutter;
  return _extends_1({
    display: 'flex',
    flexWrap: 'wrap',
    margin: "0 ".concat(!outsideGutter ? '-1rem' : 'auto'),
    width: !outsideGutter ? undefined : '100%',
    'div&': {
      padding: 0
    }
  }, media.until('sm').css({
    flexDirection: reverseLevel[0] ? 'column-reverse' : 'column'
  }), {}, media.from('sm').css(_extends_1({}, limitWidth && {
    maxWidth: rem('sm')
  }, {
    flexDirection: reverseLevel[1] ? 'column-reverse' : 'column'
  })), {}, media.from('md').css(_extends_1({}, limitWidth && {
    maxWidth: rem('md')
  }, {
    flexDirection: reverseLevel[2] ? 'column-reverse' : 'column'
  })), {}, media.from('lg').css(_extends_1({}, limitWidth && {
    maxWidth: rem('lg')
  }, {
    flexDirection: reverseLevel[3] ? 'column-reverse' : 'column'
  })), {}, media.from('xl').css(_extends_1({}, limitWidth && {
    maxWidth: rem('xl')
  }, {
    flexDirection: reverseLevel[4] ? 'column-reverse' : 'column'
  })));
});
/**
 * A mobile-first flexbox grid.
 *
 * @version ./package.json
 */

var FlexGrid = function FlexGrid(_ref3) {
  var limitWidth = _ref3.limitWidth,
      gutter = _ref3.gutter,
      outsideGutter = _ref3.outsideGutter,
      xsReverse = _ref3.xsReverse,
      smReverse = _ref3.smReverse,
      mdReverse = _ref3.mdReverse,
      lgReverse = _ref3.lgReverse,
      xlReverse = _ref3.xlReverse,
      children = _ref3.children,
      rest = objectWithoutProperties(_ref3, ["limitWidth", "gutter", "outsideGutter", "xsReverse", "smReverse", "mdReverse", "lgReverse", "xlReverse", "children"]);

  var reverseLevel = calculateLevel(xsReverse, smReverse, mdReverse, lgReverse, xlReverse);
  return React.createElement(GutterContext.Provider, {
    value: gutter
  }, React.createElement(StyledGrid, _extends_1({}, safeRest(rest), {
    fluid: true,
    outsideGutter: outsideGutter,
    reverseLevel: reverseLevel,
    limitWidth: limitWidth
  }), children));
};

FlexGrid.propTypes = {
  /**
   * Whether or not to give the grid a fixed width. This also centres the grid horizontally.
   */
  limitWidth: PropTypes.bool,

  /**
   * Whether or not to include gutters in between columns.
   */
  gutter: PropTypes.bool,

  /**
   * @since 3.1.0
   * Whether or not to include gutter at the ends to the left and right of the FlexGrid
   */
  outsideGutter: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'xs' breakpoint. When you pass in false, the order will be normal from the xs breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xsReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'sm' breakpoint. When you pass in false, the order will be normal from the sm breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  smReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'md' breakpoint. When you pass in false, the order will be normal from the md breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  mdReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'lg' breakpoint. When you pass in false, the order will be normal from the lg breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  lgReverse: PropTypes.bool,

  /**
   * Choose if the item order should be reversed from the 'xl' breakpoint. When you pass in false, the order will be normal from the xl breakpoint. By default, it inherits the behaviour set by the preceding prop.
   */
  xlReverse: PropTypes.bool,

  /**
   * The rows and columns of the Grid. Will typically be `FlexGrid.Row` and `FlexGrid.Col` components.
   */
  children: PropTypes.node.isRequired
};
FlexGrid.defaultProps = {
  limitWidth: true,
  gutter: true,
  outsideGutter: true,
  xsReverse: undefined,
  smReverse: undefined,
  mdReverse: undefined,
  lgReverse: undefined,
  xlReverse: undefined
};
FlexGrid.Row = Row;
FlexGrid.Col = Col;

export default FlexGrid;
